import { cgi as Cgi } from "@tencent/midas-cgi"
import wechatQuery from "@tencent/midas-cgi/cgis/wechat_query"
import elecInvoiceService from "@tencent/midas-cgi/cgis/elec_invoice_service_front"
import mobile_subscribe from "@tencent/midas-cgi/cgis/mobile_subscribe"

const defaultConfig = {
  hideLoading: true
}

class CgiObj {
  constructor() {
    this.cgiObj = {}
  }

  init(options) {
    if (JSON.stringify(this.cgiObj) === "{}") {
      this.cgiObj = new Cgi(options)

      this.cgiNames = {
        wechatQuery: new wechatQuery(defaultConfig),
        elecInvoiceService: new elecInvoiceService(defaultConfig),
        mobile_subscribe: new mobile_subscribe(defaultConfig)
      }
    }
  }

  request(name, params) {
    return this.cgiObj.request(this.cgiNames[name], params)
  }

  logData(params) {
    return this.cgiObj.logdata(params)
  }

  setSession(sessionObj) {
    return this.cgiObj.setSession(sessionObj)
  }
}

export default new CgiObj()
